import TOUCH_TARGET_PX from '%app/js/common/constants/touchTarget';

const COMPACT_TOUCH_TARGET_SX = {
    minWidth: { xs: TOUCH_TARGET_PX, sm: 'auto' },
    minHeight: { xs: TOUCH_TARGET_PX, sm: 'auto' },
};

export default COMPACT_TOUCH_TARGET_SX;
